// Gamest: re-init hook after cart DOM is replaced
window.__gamestReinitCartWidgets = function () {
  try {
    // Our internal event other scripts can listen for
    document.dispatchEvent(new Event("gamest:cart:updated"));
  } catch (e) {
    console.warn("Gamest reinit error:", e);
  }
};

// OPTIONAL safety fallback: if the widgets vanish after a cart update, reload cart once
(function () {
  let reloaded = false;

  function widgetsExist() {
    // Try a few likely selectors (harmless if none match)
    return Boolean(
      document.querySelector(
        '[data-flare], [class*="flare"], [id*="flare"], flare-cart-date-picker, flare-cart-time-slot'
      )
    );
  }

  document.addEventListener("gamest:cart:updated", function () {
    setTimeout(function () {
      // If widgets disappeared completely, do one soft rescue reload
      if (!widgetsExist() && !reloaded && location.pathname.includes("/cart")) {
        reloaded = true;
        location.reload();
      }
    }, 400);
  });
})();










